/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2023 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import styled from "styled-components";
import * as React from "react";

export const SafariMobileNotice: React.FC = () => (
  <SafariMobileNoticeContainer>
    <SafariMobileNoticeTitle>
      {I18n.t("enhance_speech.premium.safari_mobile_notice_title")}
    </SafariMobileNoticeTitle>
    &nbsp;{I18n.t("enhance_speech.premium.safari_mobile_notice_body")}
  </SafariMobileNoticeContainer>
);

const SafariMobileNoticeContainer = styled.div`
  background-color: var(--spectrum-green-100);
  font-size: 16px;
  border-radius: 16px;
  line-height: 20px;
  word-wrap: break-word;
  padding: 16px;
  margin-bottom: 1px;
`;

const SafariMobileNoticeTitle = styled.span`
  font-weight: 700;
`;
